import { render } from "./VipForm.vue?vue&type=template&id=670f9746&scoped=true"
import script from "./VipForm.vue?vue&type=script&lang=js"
export * from "./VipForm.vue?vue&type=script&lang=js"

import "./VipForm.vue?vue&type=style&index=0&id=670f9746&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670f9746"]])

export default __exports__